import {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  browserLanguages,
  isSupportedLocale,
} from "./config";
import type { Locale } from "./config";

/**
 * Map the browser's preferred languages to a supported locale.
 * Exact match first (`pt-BR`), then base-language match (`fr-FR` → `fr`,
 * `es-MX`/`es-419` → `es`), else the default.
 */
export const detectLocale = (
  languages: ReadonlyArray<string> = browserLanguages(),
): Locale => {
  for (const raw of languages) {
    if (!raw) continue;
    if (isSupportedLocale(raw)) return raw;
    const base = raw.split("-")[0].toLowerCase();
    const match = SUPPORTED_LOCALES.find(
      (locale) => locale.split("-")[0] === base,
    );
    if (match) return match;
  }
  return DEFAULT_LOCALE;
};

/**
 * The locale the app boots in. A persisted value is untrusted input — written
 * by an older build, it may since have been dropped from `SUPPORTED_LOCALES` —
 * so it is revalidated before it can reach the loader, and detection takes
 * over otherwise.
 */
export const resolveBootLocale = (
  persisted: string | undefined,
  languages?: ReadonlyArray<string>,
): Locale =>
  persisted && isSupportedLocale(persisted)
    ? persisted
    : detectLocale(languages);
